module.exports = __webpack_public_path__ + "img/01.81d21a8b.gif";